import { useSelector } from "react-redux";
import { selectSingleFacetConfig } from "../redux/selectors";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { type RuntimeFilterItem } from "~/HousingSelectionAssistant/types/FilterDefinitionV2";

interface Props {
  name: string;
  omitLabel?: boolean;
}

export const useHSAFacetData = ({ name, omitLabel }: Props) => {
  const config = useSelector(selectSingleFacetConfig(name));
  const { t } = useTranslation();
  const items = useMemo(() => {
    return (config?.items ?? EMPTY_LIST).map((item) => ({ ...item, label: t(item.label) }));
  }, [config?.items]);

  const label = !omitLabel && config?.label ? t(config.label) : undefined;

  return {
    label,
    values: items,
  };
};

const EMPTY_LIST: RuntimeFilterItem[] = [];
